var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"no-result"},[_c('Icon',{attrs:{"name":_vm.icon,"classes":"text-gray-300","size":"82"}}),_c('span',{staticClass:"text-gray-500 mt-4"},[_vm._v(_vm._s(_vm.$t("common.empty")))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }